import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { AddPost, GetPost, EditPost, UploadPostPic } from '../../fetchs';

import './article.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Article extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      description: '',
      picUrl: null,
      loading: false,
      saving: false,
      uploadPic: false
    }
  }

  componentDidMount() {
    const postId = this.props.match.params.postId;
    if (postId) {
      this.loadPost(postId);
    }
  }

  loadPost = (postId) => {
    this.setState({ loading: true });
    GetPost(postId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        this.setState({
          postId: responseJson.postId,
          title: responseJson.title,
          description: responseJson.description,
          picUrl: responseJson.picUrl,
        });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    if (this.props.match.params.postId) {
      EditPost(this.state.postId, {
        title: this.state.title,
        description: this.state.description,
        picUrl: this.state.picUrl
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/posts');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    } else {
      AddPost({
        title: this.state.title,
        description: this.state.description,
        picUrl: this.state.picUrl
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/posts');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  // handleRemovePic = index => {
  //   this.setState(state => {
  //     const pics = state.pics.filter((item, j) => index !== j);
  //     return {
  //       pics
  //     };
  //   });
  // }

  handleSelectFile = event => {
    this.setState({ uploadPic: true });
    UploadPostPic(this.state.postId, event.target.files[0])
      .then(response => {
        this.setState({ uploadPic: false });
        return response.json();
      }).then(responseJson => {
        this.setState({
          picUrl: responseJson.path
        })
      }).catch(error => {
        console.error(error);
      })
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن پست جدید
            </Typography>
            <Grid container>
              <Grid item md={7}>
                <React.Fragment>
                  <form className={classes.container} noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-title"
                          label="عنوان"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.title}
                          onChange={this.handleChange('title')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-available-description"
                          label="متن"
                          multiline
                          rows="4"
                          fullWidth
                          className={classes.textField}
                          value={this.state.description}
                          onChange={this.handleChange('description')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={this.state.loading}
                          onClick={this.handleSave}>ذخیره</Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
              <Grid item md={5}>
                <div>
                  <input
                    accept="image/*"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={this.handleSelectFile}
                  />
                  <label htmlFor="raised-button-file">
                    <Button
                      fullWidth
                      variant="contained"
                      component="span"
                      className={classes.button}
                    >
                      ارسال عکس جدید
                      </Button>
                    {this.state.uploadPic && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </label>
                </div>
                <div>
                  <div className="picParent">
                    <img src={`http://adminpanel.zistagram-app.ir/${this.state.picUrl}`} className="picture" alt={this.state.title} />
                  </div>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Article.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Article));
